/**
 * 默认配置
 * */
const settings = {
  namespaced: true,
  state: () => ({
    defaultNoImage: null, // 默认的图片缺失图
  }),

  mutations: {
    save(state, {payload}) {
      state.defaultNoImage = payload.defaultNoImage
    }
  },
}

export default settings

